import Role from "constants/role";
import { IOpenWidgetStateResult } from "hooks/settings/openwidget/use-openwidget-state";

import { BaseApi } from "../base";

export interface IHasTicketsResponse {
  hasTickets: boolean;
  count: number;
}

interface IUpdateIntegrationPayload {
  flags?: {
    visitedLiveChatIntegrationTutorial?: boolean;
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function parseUpdateIntegrationPayload(data: any): IUpdateIntegrationPayload {
  const payload: IUpdateIntegrationPayload = {};

  if (data.flags) {
    payload.flags = {
      visitedLiveChatIntegrationTutorial: data.flags.visitedLiveChatIntegrationTutorial,
    };
  }

  return payload;
}

export default class IntegrationsApi extends BaseApi {
  protected readonly prefix = "integrations";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = (id: string) => this.get(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAll = () => this.get();
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update = (id: string, data: IUpdateIntegrationPayload) => this.patch(id, parseUpdateIntegrationPayload(data));
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLiveChatAgents = () => this.get("livechat/agents", { imported: false });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  importLiveChatAgent = (email: string, role: Role) => this.post("livechat/agents", { email, roles: [role] });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLiveChatImport = () => this.get("livechat/import");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  startLiveChatImport = (importDataFrom?: string) =>
    this.post("livechat/import", { importModifiedSince: importDataFrom });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createLiveChatImportIntegration = () => this.post("", { type: "helpdesk" });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLivechatLicenseProperties = () => this.get("livechat/licenseProperties");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLivechatGroups = () => this.get("livechat/groups");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLiveChatSelectiveImport = () => this.get("livechat/selectiveImport");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLiveChatImportDiff = () => this.get("livechat/importDiff");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  startLiveChatSelectiveImport = (types: string[]) => this.post("livechat/selectiveImport", { types });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchOpenWidget = () => this.get<IOpenWidgetStateResult>("openwidget");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  connectOpenWidget = () => this.post("", { type: "openwidget" });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  disconnectOpenWidget = (id: string) => this.delete(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setOpenWidgetTeam = (integrationId: string, teamID: string) => this.patch(integrationId, { settings: { teamID } });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchHasTicketsToImport = () => this.get("livechat/hasTickets");
}
